// import { useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
// import BusCardSliderS1 from "../../golbal/sliders/busCardSliderS1";
// import PlansX4 from "../../golbal/sliders/plansX4";
// import api from "../../../utils/api";
// import HorizontalSlider from "../../golbal/sliders/horizontalSlider";
// import ColoredSpinner from "../../alret/spiners/coloredSpiner/coloredSpinner";
import tools from "../../../utils/tools";
// import renderData from "../../../utils/renderData";
import MetaDecorator from "../../../utils/metaDecorator";
import renderData from "../../../utils/renderData";
// import demyData from "../../../utils/demyData";

export default function DemyCenterHomeEn1() {
  const [pubData] = useOutletContext();
  // console.log("pubData", pubData);
  // const [data, setData] = useState({ center: "", program: "", level: "" });
  // console.log('demy home data' ,data);
  // const [popCat, setPopCat] = useState([]);
  // console.log("pubData", pubData);
  const navigate = useNavigate();
  const page = "demyHome";
  // const { lang, state:{state,stateShort,lat,lng}, country, countryShort } =
  // tools.getItemFromLocalStorage("initSetup", {});

  function navigateHandle(url, section) {
    window.scroll(0, 0);
    setTimeout(() => navigate(url), 200);
    const storedFilters = JSON.parse(localStorage.getItem("storedFilters"));
    if (storedFilters && storedFilters[section]) {
      delete storedFilters[section];
      localStorage.setItem("storedFilters", JSON.stringify(storedFilters));
    }
  }

  // const { translations } =
  //   JSON.parse(localStorage?.getItem("countryDetails")) ?? {};
  const title = `Academic study`;
  const description = "Find the perfect program and institution for your academic journey.";
  const structuredData = [
    // ...renderData.structuredData,
    {
      "@context": "http://schema.org",
      "@type": "WebPage",
      name: "Metademy",
      image: "https://www.metamarce.com/img/Metademy/demy-fp-en.jpg",
      url: window.location.href,
      breadcrumb: {
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            item: {
              "@id": "https://www.metamarce.com/",
              name: "Landing",              
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            item: {
              "@id": `https://www.metamarce.com/${window.lang}`,
              name: `Home`,
              },
          },
          {
            "@type": "ListItem",
            position: 3,
            item: {
              "@id": `https://www.metamarce.com/${window.lang}/demy`,
              name: `Metademy`,             
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            item: {
              "@id": `https://www.metamarce.com/${window.lang}/demy/center/home`,
              name: `Academic Centers`,             
            },
          },
        ],
      },
      // about: {
      //   "@type": "Place",
      //   name: state?.toUpperCase(),
      //   address: {
      //     "@type": "PostalAddress",
      //     // "addressLocality": "City",
      //     addressRegion: state?.toUpperCase(),
      //     // "postalCode": "Postal Code",
      //     addressCountry: country?.toUpperCase(),
      //   },
      //   geo: {
      //     "@type": "GeoCoordinates",
      //     latitude: lat, // Replace with the actual latitude
      //     longitude: lng, // Replace with the actual longitude
      //   },
      // },
    },
  ];

  const metaTagsData = {
    title,
    description,
    section: "metademy",
    url: `https://www.metamarce.com/${window.lang}/demy/center/home`,    
    img: "https://www.metamarce.com/img/Metademy/demy-fp-en.jpg",
    type: "webpage",
  };

  return (
    <div className="metademy-page metademy-page-en" dir="ltr">
      <MetaDecorator data={{ ...metaTagsData, structuredData }} />
      {/* <nav className="p-md-3 p-2 bg-beigeYellow" aria-label="breadcrumb">
  <ol className="breadcrumb">
    <li className="breadcrumb-item">
      <Link to={`/${window.lang}`}>
        خانه
      </Link>
    </li>
    <li className="breadcrumb-item">
      <strong> متادمی</strong>
    </li>
  </ol>
</nav> */}

      {/* <div className="demy-fp mt-0 text-center w-100 display-none-md">
        <img
          className="w-100 max-w-m mx-auto px-5 pb-5 "
          src="/img/Metademy/demy-fp-en.jpg"
          alt="متادمی دسکتاپ"
        />
      </div> */}
      {/* <div className="demy-fp text-center w-100 display-tablet ">
        <img
          className="w-100 max-w-1000 mx-auto px-1 pb-5 "
          src="/img/Metademy/Metademy-mobile-green-red2-en.jpg"
          alt="متادمی موبایل"
        />
      </div> */}
      {/* sections */}
      <div className="text-center max-w-1000 mx-auto my-5 en-font-family">
      <div className="tutor-frame demy-fp  mx-auto my-7 bg-deepGreen">
          <div className="row    banner-listing-2  w-100  ads-all mx-auto">
            <div className="col-md-7 bg-deepGreen d-flex flex-column align-items-md-start align-items-center justify-content-end ">
            <div className="relative z-10 text-center py-20 px-5">
        {/* Headline */}
        <h1 className="text-white text-4xl sm:text-5xl md:text-6xl font-bold my-5 ">
         <div>Explore Top Universities</div>  & Their Programs
        </h1>

        {/* Subtitle */}
        <p className="text-white text-lg sm:text-xl md:text-2xl font-medium ">
          Find the perfect program and institution for your academic journey.
        </p>

      </div>
              
            </div>
            <div className="col-md-5 bg-deepGreen d-flex align-items-center justify-content-center p-3  img-banner-2 ">
              <img
                className="w-100  rounded-2"
                src="/img/Metademy/BCU.JPG"
                // src="/img/Metademy/Metademy-students.png"
                alt="Search for a teacher "
              />
            </div>
          </div>
        </div>

        <div className="row px-5 "> 
          <div className="col-md-6 pb-3 p-3 h-100 ">
            <div class="card mx-2  border-0 shadow h-100">
            <div className="card-img-pack w-50 mx-auto ">
                    <img
                    onClick={(e)=>navigateHandle(`/en/demy/center/filters`)}
                      src="/img/Metademy/uni.png"
                        className="card-img-top  "
                      alt="programs"
                    />
                 
              </div>
              <div class="card-body">
                {/* <h4 class="card-title titr5 font-30 my-3">Programs</h4> */}
                <p class="card-text mb-5">
                Explore and compare universities to find your ideal academic environment.
                </p>
                
                <div onClick={(e)=>navigateHandle(`/en/demy/center/filters`)} class="btn primary-btn tutor-btn mx-md-5 mx-0 mb-3">
                  View Universities
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 pb-3 p-3 h-100 ">
            <div class="card mx-2  border-0 shadow h-100 ">
              <div className="card-img-pack w-50 mx-auto ">
                
                    <img
                    onClick={(e)=>navigateHandle(`/en/demy/program/filters`)}
                      src="/img/Metademy/pro.png"
                        className="card-img-top  "
                      alt="programs"
                    />
                 
              </div>
              <div class="card-body">
                {/* <h4 class="card-title titr5 font-30 my-3">Programs</h4> */}
                <p class="card-text mb-5">
                  Discover a program that aligns with your passions and career
                  goals.
                </p>

                <div onClick={(e)=>navigateHandle(`/en/demy/program/filters`)} class="btn primary-btn tutor-btn mx-md-5 mx-0 mb-3">
                  Explore programs
                </div>
              </div>
            </div>
          </div>
         
        </div>

      
        
        <div className="my-5  mx-auto ">
          <div className="row  tutor-frame banner-listing-2 w-100  max-w-m  mx-auto display-none-md">
            <img
              className="w-100 p-0 "
              src="/img/Metademy/Metademy-green-red-en-4.jpg"
              alt="tutor"
            />
            {/* </div> */}
          </div>
          <div className="demy-fp text-center w-100 display-tablet ">
            <img
              className="w-100 max-w-1000 mx-auto p-0 "
              src="/img/Metademy/Metademy-mobile-green-red-en-4.jpg"
              alt="Metademy-mobile-green-red"
            />
          </div>
          <div className="row   banner-listing-2 w-100  max-w-m mx-auto ">
            <div className="col-md-5 img-banner-text-21-5 d-flex align-items-center justify-content-center p-0  img-banner-2 "></div>
            <div className="col-md-7 img-banner-text-21-5 d-flex flex-column align-items-md-start align-items-center p-0 justify-content-end ">
              <div
                className="btn primary-btn  tutor-btn2 w-75 mx-md-5 mx-0 mb-5 mt-0"
                onClick={(e) => navigateHandle(`/${window.lang}/demy/tutor/filters`)}
              >
                <i className="bi bi-pencil-square p-1"></i>
                Find a tutor!
              </div>
              {/* <!-- </button> --> */}
            </div>
          </div>
        </div>
        <div className="my-5  mx-auto text-center">
          <div className="row  tutor-frame banner-listing-2 w-100  max-w-m  mx-auto display-none-md">
            {/* <div className="col img-banner-text-21 d-flex align-items-center justify-content-center p-lg-5 img-banner-2 "> */}
            <img
              className="w-100 p-0 "
              src="/img/Metademy/Metademy-green-red-en-2.jpg"
              alt="Metademy-green-red-en-2"
            />
            {/* </div> */}
          </div>
          <div className="demy-fp text-center w-100 display-tablet ">
            <img
              className="w-100 max-w-1000 mx-auto p-0 "
              src="/img/Metademy/Metademy-mobile-green-red-en-2.jpg"
              alt="Metademy-mobile-green-red-en-2"
            />
          </div>
          <button
            className="btn primary-btn tutor-btn bg-pinkOrange  shadow-none mt-4"
            onClick={(e) => navigateHandle(`/${window.lang}/demy/tutor/home`)}
          >
            {" "}
            <i className="bi bi-pencil-square p-1"></i> How to become a tutor
          </button>
        </div>

        {/* <!-- *********************************** end of main ******************************************************************** --> */}

        {/* <!-- ***JavaScript*** --> */}

        {/* <div>
       
        <script
          src="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/js/bootstrap.bundle.min.js"
          integrity="sha384-MrcW6ZMFYlzcLA8Nl+NtUVF0sA7MsXsP1UyJoMp4YLEuNSfAP+JcXn/tWtIaxVXM"
          crossOrigin="anonymous"
        ></script>

      
      </div> */}
      </div>
    </div>
  );
}
